import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';

import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import FluorescentOutlinedIcon from '@mui/icons-material/FluorescentOutlined';
import BubbleChartOutlinedIcon from '@mui/icons-material/BubbleChartOutlined';

import Tooltip from '@mui/material/Tooltip';

const LED_CONFIG = [
  { id: 0, icon: <FluorescentOutlinedIcon />, label: 'PA', r5Index: 6 },
  { id: 1, icon: <FluorescentOutlinedIcon />, label: 'PB', r5Index: 7 },
  { id: 2, icon: <FluorescentOutlinedIcon />, label: 'PC', r5Index: 9 },
  { id: 3, icon: <FluorescentOutlinedIcon />, label: 'PD', r5Index: 10 },
  { id: 4, icon: <LightbulbOutlinedIcon />, label: 'Light', r5Index: 15 },
  { id: 5, icon: <BubbleChartOutlinedIcon />, label: 'Blower', r5Index: 8 },
];

const LED_TOOLTIPS = {
  PA: 'Pump A',
  PB: 'Pump B',
  PC: 'Pump C',
  PD: 'Pump D',
  Light: 'Light',
  Blower: 'Blower',
};

export default function DashboardButtonLEDs() {
  const state = useContext(MainContext).state;
  const r5 = state.R5?.split(',') ?? [];

  const leds = LED_CONFIG.map((item) => ({
    ...item,
    isOn: r5[item.r5Index] === '1',
  }));

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Button LEDs
      </Typography>

      <Grid container spacing={1.5}>
        {leds.map((led) => {
          const tooltipText = LED_TOOLTIPS[led.label];

          const card = (
            <Paper
              sx={{
                p: 1.2,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                gap: 1.2,
                borderRadius: 2,
                bgcolor: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid',
                borderColor: 'rgba(255,255,255,0.1)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.08)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: led.isOn
                    ? 'success.main'
                    : 'rgba(255, 255, 255, 0.05)',
                  color: led.isOn ? '#000' : 'rgba(50,116,162,1)',
                  flexShrink: 0,
                }}
              >
                {led.icon}
              </Box>

              <Box sx={{
                  flexGrow: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: 0.3, 
                  mt: 0.4
                }}>
                <Typography
                  color="white"
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: 1.1,
                  }}
                  noWrap
                >
                  {led.label}
                </Typography>

                <Typography
                  variant="caption"
                  sx={{
                    fontSize: 13,
                    color: led.isOn ? 'success.main' : 'text.disabled',
                  }}
                >
                  {led.isOn ? 'On' : 'Off'}
                </Typography>
              </Box>
            </Paper>
          );

          return (
            <Grid item xs={6} key={led.id}>
              {tooltipText ? (
                <Tooltip title={tooltipText} arrow placement="top">
                  <Box>{card}</Box>
                </Tooltip>
              ) : (
                card
              )}
            </Grid>
          );
        })}
      </Grid>
    </React.Fragment>
  );
}
